import { Typography } from '@mui/joy';
import { t } from 'i18next';
import { Trans } from 'react-i18next';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Color, Level } from 'theme/enums';

interface IProps {
  number: number;
  solved?: boolean;
  total?: boolean;
}

const ProblemNumber = ({ number, solved = false, total = false }: IProps) => {
  const labelKey = solved ? 'labelProblemsSolved' : 'labelProblemsUnsolved';

  return (
    <Typography level={Level.TITLE_SM} color={Color.NEUTRAL}>
      <Trans
        i18nKey={labelKey}
        values={{
          count: number,
          value: !number && number !== 0 ? DEFAULT_PLACEHOLDER : number,
          prefix: total ? t('labelTotal') : '',
        }}
        components={{
          valueWrapper: <Typography color={solved ? Color.SUCCESS : Color.DANGER}></Typography>,
        }}
      />
    </Typography>
  );
};

export default ProblemNumber;
